import { useCallback, useEffect, useRef } from 'react';
import { useBusinessNames } from '../../hooks/useBusinessNames';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const useBusinessNamesSection = _ref => {
  let query = _ref.query,
    onSelectedNameChange = _ref.onSelectedNameChange,
    onUserSelectedName = _ref.onUserSelectedName,
    onNamesShown = _ref.onNamesShown;
  const _useBusinessNames = useBusinessNames({
      query
    }),
    names = _useBusinessNames.names,
    selectedName = _useBusinessNames.selectedName,
    selectName = _useBusinessNames.selectName,
    isLoading = _useBusinessNames.isLoading,
    isFetchingMore = _useBusinessNames.isFetchingMore,
    hasError = _useBusinessNames.hasError,
    ctaState = _useBusinessNames.ctaState,
    retry = _useBusinessNames.retry,
    namesPerBatch = _useBusinessNames.namesPerBatch,
    generateMore = _useBusinessNames.generateMore,
    regenerate = _useBusinessNames.regenerate;
  const lastReportedRef = useRef(undefined);
  useEffect(() => {
    const next = selectedName == null ? void 0 : selectedName.name;
    if (next && next !== lastReportedRef.current) {
      lastReportedRef.current = next;
      onSelectedNameChange == null || onSelectedNameChange(next);
    }
  }, [selectedName, onSelectedNameChange]);
  const notifiedNamesKeyRef = useRef(undefined);
  useEffect(() => {
    if (isLoading || names.length === 0) {
      return;
    }
    const key = `${query}::${JSON.stringify(names.map(n => n.id))}`;
    if (key === notifiedNamesKeyRef.current) {
      return;
    }
    notifiedNamesKeyRef.current = key;
    onNamesShown == null || onNamesShown(names);
  }, [isLoading, names, query, onNamesShown]);
  const handleSelect = useCallback(name => {
    selectName(name);
    if (name.name) {
      DomainSearchGateModule.internals.bi.onBngGeneralAction == null || DomainSearchGateModule.internals.bi.onBngGeneralAction({
        action: 'select',
        value: name.name,
        domain: name.name,
        search_term: query
      });
      onUserSelectedName == null || onUserSelectedName(name.name);
    }
  }, [selectName, onUserSelectedName, query]);
  const handleCtaClick = useCallback(() => {
    const isRegenerate = ctaState === 'regenerate';
    DomainSearchGateModule.internals.bi.onBngGeneralAction == null || DomainSearchGateModule.internals.bi.onBngGeneralAction({
      action: 'generate',
      button_name: isRegenerate ? 'regenerate new names' : 'generate more names',
      domain: '',
      search_term: query
    });
    if (isRegenerate) {
      regenerate();
    } else {
      generateMore();
    }
  }, [ctaState, generateMore, regenerate, query]);
  const handleTooltipView = useCallback(name => {
    DomainSearchGateModule.internals.bi.onBngTooltipView == null || DomainSearchGateModule.internals.bi.onBngTooltipView({
      action: 'view',
      value: name,
      domain: name,
      search_term: query
    });
  }, [query]);
  const ctaLabelKey = ctaState === 'regenerate' ? 'domain_search_gate.bng_results.names_section.regenerate_new_names.cta' : 'domain_search_gate.bng_results.names_section.generate_more_names.cta';
  return {
    names,
    selectedName,
    isLoading,
    isFetchingMore,
    hasError,
    ctaState,
    retry,
    namesPerBatch,
    handleSelect,
    handleCtaClick,
    handleTooltipView,
    ctaLabelKey
  };
};
//# sourceMappingURL=useBusinessNamesSection.js.map